import StyleWrapper from 'publisher/components/core/StyleWrapper'
import FieldErrors from 'publisher/components/FieldErrors'
import useDLocalPaymentHandler from 'publisher/hooks/payment/useDLocalPaymentHandler'
import React from 'react'
import { useCalculateButtonStyles } from 'src/publisher/shared/hooks/use-calculate-button-styles'
import { useSelectedButtonColor } from 'src/publisher/shared/hooks/use-theme-color/use-selected-button-color'
import { Button } from 'src/shared/components/button/button'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'

export interface DLocalPaymentButtonProps {
  entity: PaymentButtonEntityInterface
}

const DLocalPaymentButton = ({ entity }: DLocalPaymentButtonProps) => {
  const { errors, isLoading, handleSubmit } = useDLocalPaymentHandler(entity)

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    // calculatedTextAlign,
    // calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
  })

  const {
    buttonTextColor,
    buttonBackgroundColor,
    hoveredButtonBackgroundColor,
  } = useSelectedButtonColor(entity.buttonType)

  return (
    <StyleWrapper
      flex
      flexColumn
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <Button
        onClick={handleSubmit}
        disabled={isLoading}
        loading={isLoading}
        loadingText={entity.loadingText}
        attrId={entity.htmlAttrId}
        text={entity.text}
        subText={entity.subText}
        width={entity.width}
        mobileWidth={entity.mobileWidth}
        padding={calculatedPadding.desktop}
        mobilePadding={calculatedPadding.mobile}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        alignSelf={entity.alignSelf}
        mobileAlignSelf={entity.mobileAlignSelf}
        textColor={entity.textColor || buttonTextColor}
        mobileTextColor={entity.mobileTextColor || buttonTextColor}
        textFontSize={calculatedFontSize.desktop}
        mobileTextFontSize={calculatedFontSize.mobile}
        lineHeight={calculatedLineHeight.desktop}
        mobileLineHeight={calculatedLineHeight.mobile}
        textFontFamily={calculatedFontFamily.desktop}
        textFontStyle={calculatedFontStyle.desktop}
        textFontWeight={calculatedFontWeight.desktop}
        subTextFontSize={entity.subTextFontSize}
        mobileSubTextFontSize={entity.mobileSubTextFontSize}
        subTextColor={entity.subTextColor}
        mobileSubTextColor={entity.mobileSubTextColor}
        subTextFontFamily={entity.subTextFontFamily}
        subTextFontStyle={entity.subTextFontStyle}
        subTextFontWeight={entity.subTextFontWeight}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        hover={{
          ...entity.hover,
          backgroundColor:
            entity?.hover?.backgroundColor || hoveredButtonBackgroundColor,
        }}
        mobileHover={{
          ...entity.mobileHover,
          backgroundColor:
            entity?.mobileHover?.backgroundColor ||
            entity?.hover?.backgroundColor ||
            hoveredButtonBackgroundColor,
        }}
        background={
          (entity.background ?? entity.backgroundColor) || buttonBackgroundColor
        }
        mobileBackground={
          (entity.mobileBackground ?? entity.mobileBackgroundColor) ||
          buttonBackgroundColor
        }
        iconClassNameBefore={entity.iconClassNameBefore}
        iconClassNameAfter={entity.iconClassNameAfter}
      />
      <FieldErrors errors={errors} align="center" />
    </StyleWrapper>
  )
}

export default DLocalPaymentButton
